module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAUCAYAAAC9BQwsAAABU0lEQVQ4jZXTLU9cQRTG8d8OJLQlmGYTTJEEFASDQrUJdVzRlCARGCArKQFVRfAIPgUVFUUQqvAtfVkCuPYToKiAXMSdaWcvd2n4J5PMPOc8yZk5Z1plUciYRAevMBa13/iMPZylxJCZNvEDa5jAs7gmsBpjW3XjOnYxoD8BO7EirbIo2viFp1nSF3yM+wXMZLE/GA9YqZl2MYv3cc1GLfEEywEvM/E7tnGTaTdR+5ZprwOmM+EIZcP9yhhLTAa0M2GowZSXmGgH1WUTBYYbTMMxlrgOOM+EF/iA0UwbxUGMJS4Gcaz3uedxiZN4nsNIrYLjVlkUUzhtKO8hZoLqmT89wnSIr2nk3untXT9uscG/Wf2pmv7/sRdze37HdhL70NXwO6j6uYirBtMVlmQ9D7WELt6o7pK4xVvVHP+lbqTqayc7d/TOKRhsMMI+nqMV9/e4A24rQiHbMYhaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon.png
// module id = edSy
// module chunks = 1